module.exports = __webpack_public_path__ + "static/nfts-og-image-c4eaa4718f720dc0356f7ff6637457c4.png";